var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, } from 'react-router';
import { errors } from '@feathersjs/client';
import { EventRole } from 'src/imports/server-main/authorization.enum';
import { resetWorkspaceEvent, setWorkspaceEventEvent, setWorkspaceEventService, } from '../../reducers/workspaceEvent/actions';
import { resetScoreboard } from 'src/imports/components/Scoreboard/reducers/actions';
import Page from '../templates/Page';
import PageErrorNotFound from '../PageErrorNotFound';
import PageDashboard from './PageDashboard';
import ListUserEventRolePage from './ListUserEventRolePage';
import ListCategoryPage from './ListCategoryPage';
import ListRoundPage from './ListRoundPage';
import ListTeamPage from './ListTeamPage';
import ListAthletePage from './ListAthletePage';
import FormEventPage from './FormEventPage';
import FormCategoryPage from './FormCategoryPage';
import FormRoundPage from './FormRoundPage';
import FormTeamPage from './FormTeamPage';
import FormAthletePage from './FormAthletePage';
import FormAthleteCsvPage from './FormAthleteCsvPage';
import PageScorecard from './PageScorecard';
var WorkspaceEvent = (function (_super) {
    __extends(WorkspaceEvent, _super);
    function WorkspaceEvent(props) {
        var _this = _super.call(this, props) || this;
        _this.subscriber = {};
        _this.state = {
            subdomain: 'new',
            isFetching: true,
            isError: false,
        };
        _this.hydrateWorkspace = _this.hydrateWorkspace.bind(_this);
        _this.subscribeToWorkspace = _this.subscribeToWorkspace.bind(_this);
        _this.unsubscribeFromWorkspace = _this.unsubscribeFromWorkspace.bind(_this);
        return _this;
    }
    WorkspaceEvent.prototype.componentWillMount = function () {
        this.hydrateWorkspace(this.props.match.params.subdomain);
    };
    WorkspaceEvent.prototype.componentWillUnmount = function () {
        this.unsubscribeFromWorkspace();
    };
    WorkspaceEvent.prototype.componentWillReceiveProps = function (nextProps) {
        var nextSubdomain = nextProps.match.params.subdomain;
        var currSubdomain = this.props.match.params.subdomain;
        var workspaceEvent = nextProps.workspaceEvent;
        this.hydrateWorkspace(nextSubdomain);
        if (!nextSubdomain || nextSubdomain === 'new') {
            this.setState({ isFetching: false });
        }
        else if (nextSubdomain !== currSubdomain) {
            this.setState({ isFetching: true });
        }
        else if (workspaceEvent.userEventRoles &&
            workspaceEvent.event &&
            workspaceEvent.categories &&
            workspaceEvent.rounds &&
            workspaceEvent.roundBibs &&
            workspaceEvent.routes &&
            workspaceEvent.teams &&
            workspaceEvent.teamScores &&
            workspaceEvent.athletes &&
            workspaceEvent.athleteScores) {
            this.setState({ isFetching: false });
        }
        else {
            this.setState({ isFetching: true });
        }
    };
    WorkspaceEvent.prototype.hydrateWorkspace = function (subdomain) {
        var user = this.props.workspaceMain.user;
        var userEventRoles = this.props.workspaceMain.userEventRoles;
        var events = this.props.workspaceMain.events;
        if (!user || !userEventRoles) {
            throw new errors.GeneralError('Unable to load data from your account');
        }
        if (!events) {
            throw new errors.GeneralError('Unable to load data from this event');
        }
        if (subdomain === 'new') {
            this.setState({
                subdomain: subdomain,
                isFetching: false,
                isError: false,
            });
            this.unsubscribeFromWorkspace();
            return;
        }
        if (subdomain === this.state.subdomain) {
            return;
        }
        if (subdomain.length < 6) {
            this.setState({
                subdomain: subdomain,
                isFetching: false,
                isError: true,
                errorTitle: 'No event found',
                errorMessage: 'You may have misspelt the event\'s web address',
            });
            return;
        }
        this.setState({
            subdomain: subdomain,
            isFetching: true,
            isError: false,
        });
        try {
            var event_1 = events.find(function (e) { return e.subdomain === subdomain; });
            if (!event_1) {
                throw new errors.NotFound("We did not find any event at \"" + subdomain + ".crimp.rocks\". If you're expecting to find an event here, it may not be accessible to you any more.");
            }
            var userEventRole = userEventRoles.find(function (uER) { return uER.eventId === event_1.id && uER.userId === user.id; });
            if (!user.isAdmin &&
                (!userEventRole || userEventRole.role < EventRole.Organizer)) {
                throw new errors.Forbidden("You do not have sufficient permissions for access to the dashboard for " + subdomain + ".crimp.rocks. Please contact the organizers to grant you access.");
            }
            this.unsubscribeFromWorkspace();
            this.subscribeToWorkspace(event_1);
        }
        catch (err) {
            this.setState({
                isFetching: false,
                isError: true,
                errorTitle: '404',
                errorMessage: err.message,
            });
        }
    };
    WorkspaceEvent.prototype.subscribeToWorkspace = function (event) {
        var _this = this;
        var services = [
            'userEventRoles',
            'categories',
            'rounds',
            'roundBibs',
            'routes',
            'teams',
            'teamScores',
            'athletes',
            'athleteScores',
            'actives',
            'notifications',
        ];
        var searchQuery = {
            query: {
                eventId: event.id,
                $limit: 1000,
                $sort: { id: 1 },
            },
        };
        this.subscriber.event = feathersClient.service('events')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                id: event.id,
                $limit: 1,
                $sort: { id: 1 },
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceEventEvent(res));
        });
        services.forEach(function (s) {
            _this.subscriber[s] = feathersClient.service(s)
                .watch({ listStrategy: 'always' })
                .find(searchQuery)
                .subscribe(function (res) {
                _this.props.dispatch(setWorkspaceEventService(s, res));
            });
        });
    };
    WorkspaceEvent.prototype.unsubscribeFromWorkspace = function () {
        var _this = this;
        Object.keys(this.subscriber).forEach(function (key) {
            if (_this.subscriber[key]) {
                _this.subscriber[key].unsubscribe();
            }
        });
        this.subscriber = {};
        this.props.dispatch(resetWorkspaceEvent());
        this.props.dispatch(resetScoreboard());
    };
    WorkspaceEvent.prototype.render = function () {
        if (this.state.isError) {
            return React.createElement(PageErrorNotFound, { errorMessage: this.state.errorMessage });
        }
        if (this.state.isFetching) {
            return React.createElement(Page, { isWaiting: this.state.isFetching, waitMessage: 'Setting down pads...' });
        }
        var workspacePath = this.props.match.path;
        return (React.createElement(React.Fragment, null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: "" + workspacePath, exact: true, render: function (props) { return (props.match.params.subdomain === 'new'
                        ? React.createElement(FormEventPage, __assign({}, props))
                        : React.createElement(PageDashboard, __assign({}, props))); } }),
                React.createElement(Route, { path: workspacePath + "/event", component: FormEventPage }),
                React.createElement(Route, { path: workspacePath + "/categories", exact: true, component: ListCategoryPage }),
                React.createElement(Route, { path: workspacePath + "/categories/new", component: FormCategoryPage }),
                React.createElement(Route, { path: workspacePath + "/categories/:categoryId", component: FormCategoryPage }),
                React.createElement(Route, { path: workspacePath + "/rounds", exact: true, component: ListRoundPage }),
                React.createElement(Route, { path: workspacePath + "/rounds/new", component: FormRoundPage }),
                React.createElement(Route, { path: workspacePath + "/rounds/:roundId", component: FormRoundPage }),
                React.createElement(Route, { path: workspacePath + "/crew", component: ListUserEventRolePage }),
                React.createElement(Route, { path: workspacePath + "/athletes", exact: true, component: ListAthletePage }),
                React.createElement(Route, { path: workspacePath + "/athletes/new/import", component: FormAthleteCsvPage }),
                React.createElement(Route, { path: workspacePath + "/athletes/new", component: FormAthletePage }),
                React.createElement(Route, { path: workspacePath + "/athletes/:athleteId", component: FormAthletePage }),
                React.createElement(Route, { path: workspacePath + "/teams", exact: true, component: ListTeamPage }),
                React.createElement(Route, { path: workspacePath + "/teams/new", component: FormTeamPage }),
                React.createElement(Route, { path: workspacePath + "/teams/:teamId", component: FormTeamPage }),
                React.createElement(Route, { path: workspacePath + "/scorecard", component: PageScorecard }),
                React.createElement(Route, { component: PageErrorNotFound }))));
    };
    return WorkspaceEvent;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceMain: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        userEventRoles: state.workspaceMain.userEventRoles && state.workspaceMain.userEventRoles.data,
        events: state.workspaceMain.events && state.workspaceMain.events.data,
    },
    workspaceEvent: state.workspaceEvent,
}); };
export default connect(mapStateToProps)(WorkspaceEvent);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/index.tsx
// module id = 843
// module chunks = 0